import { generateUUID } from '@common/utils/strings';

export const generateUniqueRulename = (name) => {
  const rulename = name.replace(/_clone_\d+/, '');

  if (rulename.length > 35) {
    return `${rulename.slice(0, 10)}_${generateUUID()}`.slice(0, 40);
  }

  return `${rulename}_${generateUUID()}`.slice(0, 40);
};
